import Cookies from 'js-cookie';

export const getAccessToken = () => {
  return Cookies.get('rhyme_access_token');
};

export const getRefreshToken = () => {
  return Cookies.get('rhyme_refresh_token');
};

export const setAccessToken = (
  accessToken: string,
  accessTokenExpires: string
) => {
  Cookies.set('rhyme_access_token', accessToken, {
    expires: new Date(accessTokenExpires),
  });
};

export const setRefreshToken = (
  refreshToken: string,
  refreshTokenExpires: string
) => {
  Cookies.set('rhyme_refresh_token', refreshToken, {
    expires: new Date(refreshTokenExpires),
  });
};

export const saveTokens = (
  accessToken: string,
  accessTokenExpires: string,
  refreshToken: string,
  refreshTokenExpires: string
) => {
  setAccessToken(accessToken, accessTokenExpires);
  setRefreshToken(refreshToken, refreshTokenExpires);
};

export const removeTokens = () => {
  Cookies.remove('rhyme_access_token');
  Cookies.remove('rhyme_refresh_token');
};
